// Indice locale di TUTTE le intestazioni email dell'utente per la ricerca istantanea (nessuna attesa di rete):
// scaricato una volta da /api/emails/indice, salvato in IndexedDB, aggiornato in modo incrementale (since_ts).
import * as api from "./api";

const DB_NAME = "postaai-indice";
const STORE = "indice";
const RICARICA_COMPLETA_MS = 24 * 3600 * 1000;

const stato = { userId: null, righe: [], byId: new Map(), tsMax: 0, modMax: 0, salvatoIl: 0, versione: 0, pronto: false };
const ascoltatori = new Set();
function notifica() {
  stato.versione += 1;
  ascoltatori.forEach((f) => f(stato.versione));
}
export function onIndice(f) {
  ascoltatori.add(f);
  return () => ascoltatori.delete(f);
}

function apriDb() {
  return new Promise((res, rej) => {
    const r = indexedDB.open(DB_NAME, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(STORE);
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}
async function leggi(userId) {
  try {
    const db = await apriDb();
    return await new Promise((res) => {
      const t = db.transaction(STORE, "readonly").objectStore(STORE).get(userId);
      t.onsuccess = () => res(t.result || null);
      t.onerror = () => res(null);
    });
  } catch (e) {
    return null;
  }
}
let salvaTimer = null;
function salva() {
  clearTimeout(salvaTimer);
  salvaTimer = setTimeout(async () => {
    try {
      const db = await apriDb();
      db.transaction(STORE, "readwrite").objectStore(STORE).put({ compatte: stato.righe.map((r) => r._c), tsMax: stato.tsMax, modMax: stato.modMax, salvatoIl: stato.salvatoIl }, stato.userId);
    } catch (e) {
      console.debug("indiceLocale: salvataggio IndexedDB non riuscito", e);
    }
  }, 1500);
}

// Testo normalizzato per la ricerca: minuscolo, senza accenti
export function normalizza(s) {
  return (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
const fmtData = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric" });
const fmtOra = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit" });
function espandi(c) {
  const [id, account, folder, mittente, email, oggetto, anteprima, ts, letto, nAll, colore, categoria, pecTipo, a, preferito, inArrivo, pecRicevuta, trackingId, lettaIl, lettaN] = c;
  const d = ts ? new Date(ts * 1000) : null;
  return {
    id, account, folder, mittente, email, oggetto, corpo: anteprima, ts, letto: !!letto, colore, categoria, a,
    pec_tipo: pecTipo || undefined, preferito: !!preferito, in_arrivo: !!inArrivo, pec_ricevuta: pecRicevuta || undefined,
    tracking_id: trackingId || undefined, letta_il: lettaIl || 0, letta_n: lettaN || 0,
    allegati: nAll ? Array.from({ length: nAll }, () => ({ nome: "" })) : [],
    data: d ? fmtData.format(d).replace(/\//g, ".") : "", ora: d ? fmtOra.format(d) : "",
    light: true, indice: true,
    _c: c, _t: normalizza(`${mittente}\n${email}\n${oggetto}\n${a}\n${anteprima}`),
  };
}
function aggiungiRighe(compatte) {
  for (const c of compatte) {
    const r = espandi(c);
    const vecchia = stato.byId.get(r.id);
    if (vecchia) Object.assign(vecchia, r);
    else {
      stato.byId.set(r.id, r);
      stato.righe.push(r);
    }
    if (r.ts > stato.tsMax) stato.tsMax = r.ts;
  }
}

let caricamento = null;
export function caricaIndice(userId) {
  if (stato.userId !== userId) {
    Object.assign(stato, { userId, righe: [], byId: new Map(), tsMax: 0, modMax: 0, salvatoIl: 0, pronto: false });
    caricamento = null;
  }
  if (caricamento) return caricamento;
  caricamento = (async () => {
    const t0 = performance.now();
    const salvato = await leggi(userId);
    const completo = !salvato || Date.now() - (salvato.salvatoIl || 0) > RICARICA_COMPLETA_MS;
    if (salvato && !completo) {
      aggiungiRighe(salvato.compatte);
      stato.salvatoIl = salvato.salvatoIl;
      stato.modMax = salvato.modMax || 0;
      stato.pronto = true;
      notifica();
    }
    try {
      const r = await api.getIndice(completo ? 0 : stato.tsMax, completo ? 0 : stato.modMax);
      if (completo) {
        stato.righe = [];
        stato.byId = new Map();
        stato.tsMax = 0;
        stato.salvatoIl = Date.now();
      }
      aggiungiRighe(r.righe);
      stato.modMax = r.adesso || stato.modMax;
      stato.pronto = true;
      notifica();
      salva();
      console.info(`[indice ricerca] ${stato.righe.length} email (${completo ? "completo" : `+${r.righe.length} nuove`}) in ${Math.round(performance.now() - t0)} ms`);
    } catch (e) {
      caricamento = null;
    }
  })();
  return caricamento;
}

// Aggiornamenti locali (letta, preferito, cartella utente) senza aspettare il server
export function aggiornaIndice(id, campi) {
  const r = stato.byId.get(id);
  if (r) Object.assign(r, campi);
}
export function rimuoviDaIndice(ids) {
  const set = new Set(ids);
  if (!set.size) return;
  stato.righe = stato.righe.filter((r) => !set.has(r.id));
  ids.forEach((i) => stato.byId.delete(i));
  salva();
}
export const rigaIndice = (id) => stato.byId.get(id);
// Righe dell'indice che soddisfano un criterio (es. cartella Inviate di una casella PEC), le più recenti prima
export function filtraIndice(fn, max = 400) {
  if (!stato.pronto) return [];
  const out = stato.righe.filter(fn);
  out.sort((a, b) => (b.ts || 0) - (a.ts || 0));
  return out.length > max ? out.slice(0, max) : out;
}
export function svuotaIndice() {
  Object.assign(stato, { userId: null, righe: [], byId: new Map(), tsMax: 0, modMax: 0, pronto: false });
  caricamento = null;
  try {
    indexedDB.deleteDatabase(DB_NAME);
  } catch (e) {
    console.debug("indiceLocale: cancellazione IndexedDB non riuscita", e);
  }
}

// Ricerca istantanea: tutte le parole devono comparire (mittente, indirizzo, oggetto, destinatari, anteprima)
export function cercaIndice(q) {
  const termini = normalizza(q).split(/\s+/).filter(Boolean);
  if (!termini.length || !stato.pronto) return [];
  const t0 = performance.now();
  const out = stato.righe.filter((r) => termini.every((t) => r._t.includes(t)));
  cercaIndice.ultimoMs = performance.now() - t0;
  return out;
}
cercaIndice.ultimoMs = 0;
export const indicePronto = () => stato.pronto;
export const indiceN = () => stato.righe.length;
